import {GET_FULL_LIST} from './actionTypes'

const initialState = {
  fullList: '',
  isLoadingForFullList: false,
  hasErrorForFullList: false,
  fulfilledForFullList: false,
}

// export default (state = initialState, action) => {
//   switch (action.type) {
//     case GET_FULL_LIST:
//       return {...state, fullList: action.payload, fulfilled: true}
//
//     default:
//       return state
//   }
// };

export default (state = initialState, action) => {
  switch (action.type) {
    case `${GET_FULL_LIST}_PENDING`:
      return {
        ...state,
        fulfilledForFullList: false,
        isLoadingForFullList: true,
        hasErrorForFullList: false,
        fullList: undefined,
      }

    case `${GET_FULL_LIST}_FULFILLED`:
      return {
        fulfilledForFullList: true,
        isLoadingForFullList: false,
        hasErrorForFullList: false,
        fullList: action.payload.data,
      }

    case `${GET_FULL_LIST}_REJECTED`:
      return {
        fulfilledForFullList: false,
        isLoadingForFullList: false,
        hasErrorForFullList: true,
        fullList: undefined,
      }

    default:
      return state
  }
}
